import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";

type AssetContentProps = {
  configData: ConstraintConfigType;
};

export function AssetContent({ configData }: AssetContentProps) {
  return (
    <ConstraintContent
      configData={configData}
      dataKey="asset"
    />
  );
}
